import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../../../src/components/common/button';
import InfoMessage from '../../../../../../src/components/info-message';
import { createContainer } from '@dbk-legacy/muster/react';
import { emptyError } from '../../../../../../src/components/common/validation/validation-utils';
import styles from '../../../../../../src/screens/auth/login/login.styles';
import Text, {Small ,Large, H1 } from '@dbk/ui-text';
import config from "../../../../../../src/data/get-settings";
import DBlogo from '../../../../../../src/components/app/app-admin/dblogo';
import { PALETTE } from '../../../constants';
class Logout extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount(){
    this.props.setAuthorised(false);
  }

  render() {
    const {
      app,
      changePage,
      i18n: { messages },
      auth: {
        logoutSuccess},
      feedback
    } = this.props;
    let buttonSize;
    if(app.global.deviceInfo.isTablet){
      buttonSize = "header3";
    } else {
      buttonSize = "header4";
    }
    let message;
    if(logoutSuccess){
       message = <Large tertiary style={styles.infoContainerText}>{messages['app.auth.logoutSuccess.title']}</Large>;
    } else {
       message = <Text></Text>;
    }


    let displayMsg;
    if(feedback.ratingFeedback==true && feedback.success==true)
    {
      displayMsg=<Large style={styles.infoContainerText}>{messages['app.rating.feedbackSuccess']}</Large>;
    }
    else if(feedback.ratingFeedback==true && feedback.success==false)
    {
      displayMsg=<Large style={styles.infoContainerText}>{messages['app.rating.feedbackError']}</Large>;

    }
    else
    {
        displayMsg = <Text></Text>;
    }

    return (
      <div className="scene login">
        <div className="row">
          <div className="column small-12 medium-push-2 medium-8 large-push-3 large-6">
            <div className="callout">
              <div className="row">
                <div className="columns small-12 text-center">
                  <DBlogo/>
                  <H1 tabIndex={-1} className={"common-heading"} secondary> {messages['app.auth.logout.header']} </H1>
                  <div tabIndex={-1}>
                    <Large secondary>{displayMsg}</Large>
                  </div>
                  <div tabIndex={-1}>
                    <Large secondary>{messages['app.auth.logoutSuccess.title']}</Large>
                  </div>
                  <Large tabIndex={-1} secondary>{messages['app.auth.logoutSuccess.click']}  
                    <a 
                      href={ "../" + config.webfolder} 
                      style={{ color: PALETTE.primaryActive }}
                      onClick={window.location.reload}
                    >
                      {messages['app.auth.logoutSuccess.here']}</a> {messages['app.auth.logoutSuccess.tologin']}</Large>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    );
  }
}

Logout.propTypes = {
  changePage: PropTypes.func,
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    app:{
      global:{
        deviceInfo:{
          isTablet: true,
        },
      },
    },
    setAuthorised: { $call: 'auth.setAuthorised' },
    auth: {
      onLogout: { $call: 'logout' },
      logoutSuccess: true,
    },
    feedback:{
      success: true,
      ratingFeedback:true
    },
    i18n: {
      messages: true,
    },
  },
}, ({...queries }) => ({
  ...queries,
}))(Logout);



